import { Input } from '@angular/core'
import { FormGroup } from '@angular/forms'

import { Question, QUESTION_TYPE_KEYS, AnswerChoiceGroup } from '../../../../data/models'
import { BasePrompt, Form, MultiRelationshipPrompt } from '../../../../forms/models'
import { IQuestionAnswer, QuestionViewService } from '../'

const LAYOUT_MAP = {
  vertical: 'col-xs-12 vertical',
  horizontal: 'col-xs-12 col-sm-6 horizontal'
}

export class QuestionTypeView {
  @Input() public question: Question
  @Input() public form: Form<Question>
  @Input() public formGroup: FormGroup
  @Input() public config: {} = {}

  public constructor(
    protected _questionViewService: QuestionViewService
  ) { }

  public get textQuestionPrompt() {
    return this.question.getQuestionPrompt(QUESTION_TYPE_KEYS.QUESTION_TEXT)
  }

  public get answerChoiceGroupPrompt(): MultiRelationshipPrompt<AnswerChoiceGroup> {
    return this.form.getPrompt<MultiRelationshipPrompt<AnswerChoiceGroup>>('answerChoiceGroup')
  }

  public get firstAnswerChoicePrompt() {
    return this.answerChoiceGroupPrompt.forms[0].getPrompt('answerChoice')
  }

  public get firstAnswerChoiceFormGroup() {
    return this.answerChoiceGroupsFormGroup.get('0')
  }

  public get answerChoiceGroupsFormGroup() {
    return this.formGroup.get(this.answerChoiceGroupPrompt.key)
  }

  public getAnswerChoiceGroupForm(index: number) {
    return this.answerChoiceGroupPrompt.forms[index]
  }

  public getAnswerChoiceGroupFormGroup(index: number) {
    return this.answerChoiceGroupsFormGroup.get(index.toString())
  }

  public getAnswerChoicePrompt<T extends BasePrompt<any>>(index: number): T {
    return this.getAnswerChoiceGroupForm(index).getPrompt('answerChoice')
  }

  public layoutClass(): string {
    const layout = Object.assign({}, LAYOUT_MAP, this.config)
    return layout[this.config['layout']] || layout['horizontal']
  }

  public getQuestionAnswers():IQuestionAnswer[] {
    return this.formGroup.value.answerChoiceGroup.reduce((previous:IQuestionAnswer[],value,inndex)=>{
      if(value.answerChoice){
        previous.push({choiceId: value.answerChoice , value:''})
      }
      return previous
    }, [])
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/angular/components/question-view/question-type-view/question-type-view.ts